import {ICellRendererParams} from "@ag-grid-community/core";
import {Text, Tooltip} from "@blueprintjs/core";
import styled from "@emotion/styled";

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const CellRendererWithToolTip = (props: ICellRendererParams<any, string | undefined>) => {
  return (
    <Tooltip fill placement={"top"} content={props.value}>
      <Container>
        <Text ellipsize>{props.value}</Text>
      </Container>
    </Tooltip>
  );
};
